import { NewTrainingWizard } from 'modules/trainings/components/Revamp/NewTrainingWizard'

export default function TrainingWizard() {
  return <NewTrainingWizard />
}
